import { Campaign } from "./campaign.model";
import { DiscountTarget } from "./discount-target.enum";
import { ProductType } from "./product-type.model";

    /**
     * @description
     *  Modelo de un descuento.
     *
     * @see gigot-backend/Models/Configuration/Discount.cs
     */

export class Discount {

    public campaign: Campaign;
	public campaignId: number;
	public discountValue: number;
	public fromAmount: number;
	public fromQuantity: number;
	public id: number;
	public productType: ProductType;
	public productTypeId: number;
	public target: DiscountTarget;
	public toAmount: number;
	public toQuantity: number;

    /**
     * @description
     *	Construye un descuento con una semántica vacía. Nótese que no es lo
     *  mismo que construir un descuento con valores por defecto. Las reglas
     *  generales de construcción son:
     *
     *      - Campos 'array' se definen como [].
     *      - Campos 'boolean' se definen como 'false'.
     *      - Campos 'Date' se definen como 'undefined'.
     *      - Campos 'enum' se definen como 'undefined'.
     *      - Campos 'number' se definen como 'undefined'.
     *      - Campos 'string' se definen como '' (cadena vacía).
     *      - Campos 'object' se definen llamando a su propio método #empty().
     *      - Campos de la superclase se definen al igual que campos 'object'.
     *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
     *
     * @returns
     *	Un descuento vacío.
     */
    public static empty(): Discount {
        const discount: Discount = new Discount();
		discount.campaign = Campaign.empty();
		discount.campaignId = undefined;
		discount.discountValue = undefined;
		discount.fromAmount = undefined;
		discount.fromQuantity = undefined;
		discount.id = undefined;
		discount.productType = ProductType.empty();
		discount.productTypeId = undefined;
		discount.target = undefined;
		discount.toAmount = undefined;
		discount.toQuantity = undefined;
        return discount;
    }

	/**
     * @description
     *  Método de reificación de un modelo compatible anémico. Esto permite
     *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
     *  valor de sus propiedades se mantiene.
     *
     * @param anemicDiscount
     *  El modelo anémico a reificar.
     *
     * @returns
     *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
     *  profundidad desde el modelo anémico.
     */
	public static from(anemicDiscount: Discount): Discount {
		if (!anemicDiscount) return undefined;
        const discount: Discount = Discount.empty();
		discount.campaign = Campaign.from(anemicDiscount.campaign);
		discount.campaignId = anemicDiscount.campaignId;
		discount.discountValue = anemicDiscount.discountValue;
		discount.fromAmount = anemicDiscount.fromAmount;
		discount.fromQuantity = anemicDiscount.fromQuantity;
		discount.id = anemicDiscount.id;
		discount.productType = ProductType.from(anemicDiscount.productType);
		discount.productTypeId = anemicDiscount.productTypeId;
		discount.target = anemicDiscount.target;
		discount.toAmount = anemicDiscount.toAmount;
		discount.toQuantity = anemicDiscount.toQuantity;
		return discount;
	}
}
